export default "__VITE_PUBLIC_ASSET__83ad6bf2__"